import { ReactElement, useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import { useField } from 'formik';
import noop from 'lodash/noop';

import { useSaved } from '@/hooks/use-saved';

import { FieldProps, OutputValue } from './types';

const Field = <T,>({
  name,
  render,
}: {
  name: string;
  render: (props: Omit<FieldProps<T>, 'required'>) => ReactElement | null;
}): ReactElement | null => {
  const { t } = useTranslation();

  const [field, meta, actions] = useField(name);

  const error = useMemo(() => {
    if (!meta.touched || !meta.error) {
      return '';
    }
    return t(meta.error);
  }, [meta.error, t, meta.touched]);

  return render({
    name,
    value: field.value,
    onChange: value => actions.setValue(value),
    onBlur: () => actions.setTouched(true),
    error
  })
};

export default Field;
